<!-- StarRating.vue -->
<template>
  <div class="star-rating">
    <span v-for="index in starQuantity" :key="index" class="stars" :class="{ filled: index <= fullStars }">
      <template v-if="(index > fullStars && Math.ceil(score) == index ) && hasHalfStar">
        <span class="star half"></span>
      </template>
      <template v-else>
        <span v-if="index <= score" class="star on"></span>
        <span v-else class="star"></span>
      </template>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      required: true,
    },
    starQuantity: {
      type: Number,
      required: true,
    },
  },
  computed: {
    fullStars() {
      return Math.floor(this.score)
    },
    hasHalfStar() {
      return this.score % 1 !== 0
    },
  },
}
</script>

<style lang="scss" scoped>
.star {
  font-size: x-large;
  display: inline-block;
  color: var(--gray-400);
  width: 23px;
}
.star:last-child {
  margin-right: 0;
}
.star:before {
  content: '\2605';
}
.star.on {
  color: var(--gold);
}
.star.half:after {
  content: '\2605';
  color: var(--gold);
  position: absolute;
  margin-left: -20px;
  width: 10px;
  overflow: hidden;
}
</style>
